<template>
  <div>
      <div >
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
              <el-form-item label="保单名称" prop="ide">
                <el-select v-model="ruleForm.ide" style="width:100%" placeholder="请选择保单名称" clearable>
                        <el-option
                          v-for="item in bdList"
                          :key="item.id"
                          :label="item.insurance_name"
                          :value="item.id">
                        </el-option>
                      </el-select>
            </el-form-item>

            <el-form-item label="保单号" prop="policy_no">
                <el-input v-model="ruleForm.policy_no" placeholder="请输入甲方名称"></el-input>
            </el-form-item>

            <el-form-item style="margin-left:30px">
                <el-button type="goon" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
            </el-form>
      </div>

  </div>
</template>

<script>
export default {
   data() {
      return {
        bdList:[],
        ruleForm: {
          ide:'',
          policy_no:'',
          insurance_name:'',
        },
        rules: {
            ide: [
            { required: true, message: '请选择', trigger: 'blur' },
          ],
          policy_no: [
            { required: true, message: '请输入保单号', trigger: 'blur' },
          ],
        }
      };
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    },
    async created() {
     // 保单
     debugger
    var bdList = await this.$globals.AxiosPost("OtherInsurance/SelectKey", {});
    this.bdList = bdList.data; 
    this.ruleForm = this.$parent.ruleForm; 
  },
}
</script>

<style>
.el-checkbox__input.is-checked+.el-checkbox__label{
    color: #006E4B;
}
.el-input{
    width: 80%;
}

</style>


// WEBPACK FOOTER //
// Gzxgl_pipei.vue?b47be632